module.exports = __webpack_public_path__ + "static/assets/2eafbafeeadf6ee799e6d04b4f21649b.png";